const TYPES = require('reducers/inline-basket').ACTION_TYPES;

function addedProductsNotification(addedProductsCount) {
    return {
        type: TYPES.ADDED_PRODUCTS_NOTIFICATION,
        justAddedProducts: addedProductsCount
    };
}

function ReserveOnlinePickUpInStoreProductAdded(isRopisSkuAdded) {
    return {
        type: TYPES.ROPIS_PRODUCT_ADDED,
        isRopisSkuAdded: isRopisSkuAdded
    };
}

module.exports = {
    TYPES,
    addedProductsNotification: addedProductsNotification,
    ReserveOnlinePickUpInStoreProductAdded: ReserveOnlinePickUpInStoreProductAdded
};
